import { type Currency } from "@vega-api/generated/types/currency";
import { DealMetricType } from "@vega-api/generated/types/dealMetricType";
import { type DealOverviewMetricRequest } from "@vega-api/generated/types/dealOverviewMetricRequest";
import { type DealOverviewMetricResponse } from "@vega-api/generated/types/dealOverviewMetricResponse";
import { type Money } from "@vega-api/generated/types/money";

// Form representation of a money metric
type MoneyValue = Omit<Money, "amount"> & { amount: string };

export type FormMetric = Omit<DealOverviewMetricRequest, "value"> & {
  value: MoneyValue | string;
};

export const isMoneyValue = (value: FormMetric["value"]): value is MoneyValue =>
  typeof value === "object" && "currency" in value && "amount" in value;

export const transformMetricsForForm = (
  metrics: DealOverviewMetricResponse[],
): FormMetric[] =>
  metrics.map(({ currency, ...metric }) => ({
    ...metric,
    value:
      metric.type === DealMetricType.MONEY
        ? { amount: metric.value, currency: currency as Currency }
        : metric.value,
  }));

export const transformMetricsForApi = (
  metrics: FormMetric[],
): DealOverviewMetricRequest[] =>
  metrics.map((metric) => ({
    id: metric.id,
    name: metric.name,
    type: metric.type,
    description: metric.description,
    source: metric.source,
    isEditable: metric.isEditable,
    value:
      metric.type === DealMetricType.MONEY && isMoneyValue(metric.value)
        ? metric.value.amount
        : (metric.value as string),
  }));
